// Convert any date to IST (UTC + 5:30) and format YYYY-MM-DD
const toIST = (date) => {
  const istOffset = 5.5 * 60 * 60 * 1000; // +5:30 hrs in milliseconds
  const istTime = new Date(date.getTime() + istOffset);
  return istTime.toISOString().split("T")[0];
};

export default toIST;
